import styled, { keyframes } from 'styled-components';

interface TabsProps {
  $activeIndex: number;
}
interface FilterProps {
  $isFilter: boolean;
}

export const fadeIn = keyframes`
0% {
   width: 0;
 }

 100% {
  width: 100%;
 }
`;

export const Tabs = styled.div<TabsProps>`
  button {
    background: transparent;
    border: none;
    color: ${props => props.theme.fontColor};
    margin-top: 1rem;
    padding: 0.5rem 0.2rem;
    position: relative;

    transition: font-weight 0.2 ease-in-out;

    &:nth-child(${({ $activeIndex }) => $activeIndex}) {
      font-weight: 600;
      &::before {
        animation: ${fadeIn} 0.2s forwards;
        content: '';
        position: absolute;
        height: 2px;
        width: 100%;
        bottom: -2px;
        background-color: ${({ theme }) => theme.fontColor};
      }
    }
  }
`;

export const FilterSection = styled.section<FilterProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  .upperFilter {
    display: flex;
    > div {
      margin-left: 0.3rem;
      width: 200px;
    }
  }

  .optionButton {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 412px;
    > div {
      margin-left: 0.3rem;
      &:nth-of-type(2) {
        width: 100px;
        .filtroStatus {
          min-width: 100px;
          > div {
            width: 100px;
          }
        }
      }
      .painelButton {
        display: flex;
        justify-content: space-between;
        > button {
          height: 35px;
        }
      }
    }
  }
`;
